import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

// const originalPush = VueRouter.prototype.push
// //修改原型对象中的push方法
// VueRouter.prototype.push = function push(location) {
//    return originalPush.call(this, location).catch(err => err)
// }

const routes = [
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/form/:id",
    name: "Form",
    component: () =>
      import(/* webpackChunkName: "form" */ "../views/form/index.vue"),
    meta: {
      parentMenu: "Home",
    },
  },
  {
    path: "/work-order/success",
    name: "WorkOrderSuccess",
    component: () =>
      import(
        /* webpackChunkName: "WorkOrderSuccess" */ "../views/sph/qrcode.vue"
      ),
    meta: {
      parentMenu: "Home",
      title: "提交成功",
    },
  },
  {
    path: "/work-order/list",
    name: "WorkOrderList",
    component: () =>
      import(/* webpackChunkName: "list" */ "../views/WorkOrderList.vue"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/work-order/detail",
    name: "WorkOrderDetail",
    component: () =>
      import(
        /* webpackChunkName: "WorkOrderDetail" */ "../views/WorkOrderDetail.vue"
      ),
    meta: {
      parentMenu: "WorkOrderList",
    },
  },
  {
    path: "/work-order/call-records",
    name: "WorkOrderCallRecords",
    component: () =>
      import(
        /* webpackChunkName: "WorkOrderCallRecords" */ "../views/call-records.vue"
      ),
    meta: {
      noHeader: true,
      title: "通话记录",
    },
  },
  {
    path: "/work-order/rights",
    name: "WorkOrderRights",
    component: () =>
      import(/* webpackChunkName: "WorkOrderRights" */ "../views/rights.vue"),
    meta: {
      noHeader: true,
      title: "权益详情",
    },
  },
  {
    path: "/work-order/fangai-rights",
    name: "WorkOrderFangaiRights",
    component: () =>
      import(
        /* webpackChunkName: "WorkOrderFangaiRights" */ "../views/fangaiRights.vue"
      ),
    meta: {
      noHeader: true,
      title: "权益详情",
    },
  },
  {
    path: "/work-order/check-up/customer-status",
    name: "CustomerStatus",
    component: () =>
      import(
        /* webpackChunkName: "CustomerStatus" */ "../views/workOrder/checkUp/customerStatus.vue"
      ),
    meta: {
      noHeader: true,
      title: "客户状态",
    },
  },
  {
    path: "/work-order/check-up/customer-logs",
    name: "CustomerLogs",
    component: () =>
      import(
        /* webpackChunkName: "CustomerLogs" */ "../views/workOrder/checkUp/customerLogs.vue"
      ),
    meta: {
      noHeader: true,
      title: "服务日志",
    },
  },
  {
    path: "/work-order/appDetails",
    name: "AppDetails",
    component: () =>
      import(
        /* webpackChunkName: "AppDetails" */ "../views/workOrder/appDetails.vue"
      ),
    meta: {
      noHeader: true,
      title: "预约详情",
    },
  },

  {
    path: "/bug/view",
    name: "BugView",
    component: () =>
      import(/* webpackChunkName: "BugView" */ "../views/bug/view.vue"),
    meta: {
      noHeader: true,
    },
  },
  {
    path: "/news/list/:type",
    name: "NewsList",
    component: () =>
      import(/* webpackChunkName: "NewsList" */ "../views/news/list.vue"),
    meta: {
      title: "健康资讯",
    },
  },
  {
    path: "/news/detail/:id",
    name: "NewsDetail",
    component: () =>
      import(/* webpackChunkName: "NewsDetail" */ "../views/news/detail.vue"),
    meta: {
      title: "健康资讯",
    },
  },
  {
    path: "/news/search/:type",
    name: "NewsSearch",
    component: () =>
      import(/* webpackChunkName: "NewsDetail" */ "../views/news/search.vue"),
    meta: {
      title: "健康宣教",
    },
  },
  {
    path: "/reserve/table",
    name: "ReserveTable",
    component: () =>
      import(
        /* webpackChunkName: "ReserveTable" */ "../views/reserve/table.vue"
      ),
    meta: {
      title: "预约监控",
      noHeader: true,
    },
  },
  //
  {
    path: "/reserve/calendar",
    name: "ReserveCalendar",
    component: () =>
      import(
        /* webpackChunkName: "ReserveCalendar" */ "../views/reserve/calendar.vue"
      ),
    meta: {
      title: "预约监控",
      noHeader: true,
    },
  },
  {
    path: "/reserve/achievement",
    name: "ReserveAchievement",
    component: () =>
      import(
        /* webpackChunkName: "ReserveAchievement" */ "../views/reserve/achievement.vue"
      ),
    meta: {
      title: "门诊渠道业绩统计",
      noHeader: true,
    },
  },
  {
    path: "/chat",
    name: "AiChat",
    component: () => import("@/components/chat/index.vue"),
  },
  {
    path: "/reserve/complaint",
    name: "ReserveComplaint",
    component: () =>
      import(
        /* webpackChunkName: "ReserveComplaint" */ "../views/reserve/complaint.vue"
      ),
    meta: {
      title: "投诉监控",
      noHeader: true,
    },
  },
  {
    path: "/reserve/addWx",
    name: "ReserveAddWx",
    component: () =>
      import(
        /* webpackChunkName: "ReserveAddWx" */ "../views/reserve/addWx.vue"
      ),
    meta: {
      title: "每日加微报表",
      noHeader: true,
    },
  },
  {
    path: "/reserve/channel",
    name: "ReserveChannel",
    component: () =>
      import(
        /* webpackChunkName: "ReserveChannel" */ "../views/reserve/channel.vue"
      ),
    meta: {
      title: "渠道业绩报表",
      noHeader: true,
    },
  },
  {
    path: "/reserve/label",
    name: "ReserveLabel",
    component: () =>
      import(
        /* webpackChunkName: "ReserveChannel" */ "../views/reserve/channelLabel.vue"
      ),
    meta: {
      title: "每日渠道标签报表",
      noHeader: true,
    },
  },
  {
    path: "/offsite/index",
    name: "Offsite",
    component: () =>
      import(/* webpackChunkName: "offsite" */ "../views/offsite/index.vue"),
    meta: {
      title: "异地会销预约",
      noHeader: true,
    },
  },
  {
    path: "/offsite/add",
    name: "OffsiteAdd",
    component: () =>
      import(/* webpackChunkName: "offsiteAdd" */ "../views/offsite/add.vue"),
    meta: {
      title: "新增预约",
      noHeader: true,
    },
  },
  {
    path: "/offsite/detail",
    name: "OffsiteDetail",
    component: () =>
      import(
        /* webpackChunkName: "offsiteDetail" */ "../views/offsite/detail.vue"
      ),
    meta: {
      title: "会销详情",
      noHeader: true,
    },
  },
  {
    path: "/sph",
    name: "Sph",
    component: () =>
      import(/* webpackChunkName: "Sph" */ "../components/layouts/sph.vue"),
    meta: {
      noHeader: true,
    },
    children: [
      {
        path: "survey",
        name: "SphSurvey",
        component: () =>
          import(/* webpackChunkName: "SphSurvey" */ "../views/sph/survey.vue"),
        meta: {
          noHeader: true,
          title: "请完善个人信息",
        },
      },
      {
        path: "qrcode",
        name: "SphQrcode",
        component: () =>
          import(/* webpackChunkName: "SphQrcode" */ "../views/sph/qrcode.vue"),
        meta: {
          noHeader: true,
          title: "提交成功",
        },
      },
    ],
  },
  {
    path: "/salon",
    name: "Salon",
    component: () =>
      import(/* webpackChunkName: "Salon" */ "../components/layouts/salon.vue"),
    meta: {
      noHeader: true,
    },
    children: [
      {
        path: "home",
        name: "SalonHome",
        component: () =>
          import(/* webpackChunkName: "SalonHome" */ "../views/salon/home.vue"),
        meta: {
          noHeader: true,
          title: "沙龙预约",
        },
      },
      {
        path: "reservation",
        name: "SalonReservation",
        component: () =>
          import(
            /* webpackChunkName: "SalonReservation" */ "../views/salon/reservation.vue"
          ),
        meta: {
          noHeader: true,
          title: "沙龙预约",
        },
      },
      {
        path: "add",
        name: "SalonAdd",
        component: () =>
          import(/* webpackChunkName: "SalonAdd" */ "../views/salon/add.vue"),
        meta: {
          noHeader: true,
          title: "沙龙预约",
        },
      },
      {
        path: "list",
        name: "SalonList",
        component: () =>
          import(/* webpackChunkName: "SalonList" */ "../views/salon/list.vue"),
        meta: {
          noHeader: true,
          title: "我的预订",
        },
      },
      {
        path: "detail",
        name: "SalonDetail",
        component: () =>
          import(
            /* webpackChunkName: "SalonDetail" */ "../views/salon/detail.vue"
          ),
        meta: {
          noHeader: true,
          title: "会议详情",
        },
      },
      {
        path: "table",
        name: "SalonTable",
        component: () =>
          import(
            /* webpackChunkName: "SalonTable" */ "../views/salon/table.vue"
          ),
        meta: {
          noHeader: true,
          title: "沙龙统计",
        },
      },
    ],
  },
  {
    path: "/vaccinum",
    name: "Vaccinum",
    component: () =>
      import(/* webpackChunkName: "Salon" */ "../components/layouts/salon.vue"),
    meta: {
      noHeader: true,
    },
    children: [
      {
        path: "chart",
        name: "VaccinumChart",
        component: () =>
          import(
            /* webpackChunkName: "VaccinumChart" */ "../views/vaccinum/chart.vue"
          ),
        meta: {
          noHeader: true,
          title: "疫苗监控",
        },
      },
      {
        path: "daily",
        name: "VaccinumDaily",
        component: () =>
          import(
            /* webpackChunkName: "VaccinumInlet" */ "../views/vaccinum/inlet.vue"
          ),
        meta: {
          noHeader: true,
          title: "运营报表",
        },
      },
      {
        path: "operate",
        name: "VaccinumOperate",
        component: () =>
          import(
            /* webpackChunkName: "VaccinumOperate" */ "../views/vaccinum/daily.vue"
          ),
        meta: {
          noHeader: true,
          title: "运营日报",
        },
      },
      {
        path: "table",
        name: "VaccinumTable",
        component: () =>
          import(
            /* webpackChunkName: "VaccinumTable" */ "../views/vaccinum/table.vue"
          ),
        meta: {
          noHeader: true,
          title: "招商系客户消费明细",
        },
      },
      {
        path: "cardDetail",
        name: "VaccinumCardDetail",
        component: () =>
          import(
            /* webpackChunkName: "VaccinumCardDetail" */ "../views/vaccinum/cardDetail.vue"
          ),
        meta: {
          noHeader: true,
          title: "卡详情查询",
        },
      },
    ],
  },
  {
    path: "/wecom",
    name: "Wecom",
    component: () =>
      import(/* webpackChunkName: "Wecom" */ "../components/layouts/wecom.vue"),
    meta: {
      title: "企业微信",
    },
    children: [
      {
        path: "member-list",
        name: "WecomMemberList",
        component: () => import("@/views/wecom/MemberList.vue"),
        meta: {
          title: "成员列表",
          keepAlive: true,
        },
      },
      {
        path: "message-send",
        name: "MessageSend",
        component: () => import("@/views/wecom/MessageSend.vue"),
        meta: {
          title: "发送消息",
        },
      },
      {
        path: "push-task-list",
        name: "PushTaskList",
        component: () => import("@/views/wecom/PushTaskList.vue"),
        meta: {
          title: "推送任务列表",
        },
      },
      {
        path: "group-manage",
        name: "GroupManage",
        component: () => import("@/views/wecom/GroupManage.vue"),
        meta: {
          title: "分组管理",
        },
      },
    ],
  },

  {
    path: "/pd1",
    name: "Pd1",
    component: () =>
      import(/* webpackChunkName: "Salon" */ "../components/layouts/salon.vue"),
    meta: {
      noHeader: true,
    },
    children: [
      {
        path: "rights",
        name: "Pd1Rights",
        component: () =>
          import(/* webpackChunkName: "Pd1Rights" */ "../views/pd1/rights.vue"),
        meta: {
          noHeader: true,
          title: "权益详情",
        },
      },
      {
        path: "handbook",
        name: "Pd1Handbook",
        component: () =>
          import(
            /* webpackChunkName: "Pd1Handbook" */ "../views/pd1/handbook.vue"
          ),
        meta: {
          noHeader: true,
          title: "服务手册",
        },
      },
      {
        path: "means",
        name: "Pd1Means",
        component: () =>
          import(/* webpackChunkName: "Pd1Means" */ "../views/pd1/means.vue"),
        meta: {
          noHeader: true,
          title: "客户资料",
        },
      },
      {
        path: "file",
        name: "Pd1File",
        component: () =>
          import(/* webpackChunkName: "Pd1File" */ "../views/pd1/file.vue"),
        meta: {
          noHeader: true,
          title: "客户文件",
        },
      },
      {
        path: "flow",
        name: "Pd1Flow",
        component: () =>
          import(/* webpackChunkName: "Pd1Flow" */ "../views/pd1/flow.vue"),
        meta: {
          noHeader: true,
          title: "完善内容",
        },
      },
      {
        path: "pharmacyFinder",
        name: "Pd1PharmacyFinder",
        component: () =>
          import(
            /* webpackChunkName: "Pd1PharmacyFinder" */ "../views/pd1/pharmacyFinder.vue"
          ),
        meta: {
          keepAlive: true,

          noHeader: true,
          title: "药房查询",
        },
      },
      {
        path: "drug",
        name: "Pd1Drug",
        component: () =>
          import(/* webpackChunkName: "Pd1Drug" */ "../views/pd1/drug.vue"),
        meta: {
          noHeader: true,
          title: "维护药品信息",
        },
      },
      {
        path: "payConfirm",
        name: "Pd1PayConfirm",
        component: () =>
          import(
            /* webpackChunkName: "Pd1PayConfirm" */ "../views/pd1/payConfirm.vue"
          ),
        meta: {
          noHeader: true,
          title: "垫付信息确认",
        },
      },
    ],
  },
  {
    path: "/booking",
    name: "Booking",
    component: () =>
      import(
        /* webpackChunkName: "Booking" */ "../components/layouts/booking.vue"
      ),
    meta: {
      noHeader: true,
    },
    children: [
      {
        path: "home",
        name: "BookingHome",
        component: () =>
          import(
            /* webpackChunkName: "BookingHome" */ "../views/booking/home.vue"
          ),
        meta: {
          keepAlive: true,
          noHeader: true,
          title: "预约申请",
        },
      },
      {
        path: "plan",
        name: "BookingPlan",
        component: () =>
          import(
            /* webpackChunkName: "BookingPlan" */ "../views/booking/plan.vue"
          ),
        meta: {
          keepAlive: false,
          noHeader: true,
          title: "预约时间",
        },
      },
      {
        path: "add",
        name: "BookingAdd",
        component: () =>
          import(
            /* webpackChunkName: "BookingAdd" */ "../views/booking/addForm.vue"
          ),
        meta: {
          noHeader: true,
          title: "新增客户",
        },
      },
      {
        path: "list",
        name: "BookingList",
        component: () =>
          import(
            /* webpackChunkName: "BookingList" */ "../views/booking/list.vue"
          ),
        meta: {
          noHeader: true,
          title: "历史记录",
        },
      },
      {
        path: "collect",
        name: "BookingCollect",
        component: () =>
          import(
            /* webpackChunkName: "BookingCollect" */ "../views/booking/collect.vue"
          ),
        meta: {
          noHeader: true,
          keepAlive: true,

          title: "预收",
        },
      },
      {
        path: "collectList",
        name: "BookingCollectList",
        component: () =>
          import(
            /* webpackChunkName: "BookingCollectList" */ "../views/booking/collectList.vue"
          ),
        meta: {
          noHeader: true,
          title: "历史记录",
        },
      },
      {
        path: "product",
        name: "BookingProduct",
        component: () =>
          import(
            /* webpackChunkName: "BookingProduct" */ "../views/booking/product.vue"
          ),
        meta: {
          noHeader: true,
          title: "选择产品",
        },
      },
      {
        path: "success",
        name: "BookingSuccess",
        component: () =>
          import(
            /* webpackChunkName: "BookingSuccess" */ "../views/booking/success.vue"
          ),
        meta: {
          noHeader: true,
          title: "提交成功",
        },
      },
      {
        path: "message",
        name: "BookingMessage",
        component: () =>
          import(
            /* webpackChunkName: "BookingMessage" */ "../views/booking/message.vue"
          ),
        meta: {
          noHeader: true,
          title: "消息",
        },
      },
      {
        path: "management",
        name: "BookingManagement",
        component: () =>
          import(
            /* webpackChunkName: "BookingManagement" */ "../views/booking/management.vue"
          ),
        meta: {
          noHeader: true,
          title: "编辑",
        },
      },
      {
        path: "addNotes",
        name: "BookingAddNotes",
        component: () =>
          import(
            /* webpackChunkName: "BookingAddNotes" */ "../views/booking/addNotes.vue"
          ),
        meta: {
          noHeader: true,
          title: "追加备注",
        },
      },

      {
        path: "orderManage",
        name: "BookingOrderManage",
        component: () =>
          import(
            /* webpackChunkName: "BookingOrderManage" */ "../views/booking/orderManage.vue"
          ),
        meta: {
          noHeader: true,
          title: "编辑订单",
        },
      },
      {
        path: "qrCode",
        name: "BookingQrCode",
        component: () =>
          import(
            /* webpackChunkName: "BookingQrCode" */ "../views/booking/qrCode.vue"
          ),
        meta: {
          noHeader: true,
          title: "提交成功",
        },
      },
      {
        path: "refund",
        name: "BookingRefund",
        component: () =>
          import(
            /* webpackChunkName: "BookingRefund" */ "../views/booking/refund.vue"
          ),
        meta: {
          noHeader: true,
          title: "回款录入",
        },
      },
      {
        path: "refundDetail",
        name: "BookingRefundDetail",
        component: () =>
          import(
            /* webpackChunkName: "BookingRefundDetail" */ "../views/booking/refundDetail.vue"
          ),
        meta: {
          noHeader: true,
          title: "回款录入明细",
        },
      },
      {
        path: "wangning",
        name: "BookingWangning",
        component: () =>
          import(
            /* webpackChunkName: "BookingWangning" */ "../views/booking/wangning.vue"
          ),
        meta: {
          noHeader: true,
          title: "王宁code",
        },
      },
    ],
  },
  {
    path: "/appointment",
    name: "Appointment",
    component: () =>
      import(
        /* webpackChunkName: "Booking" */ "../components/layouts/booking.vue"
      ),
    meta: {
      noHeader: true,
    },
    children: [
      {
        path: "home",
        name: "AppointmentHome",
        component: () =>
          import(
            /* webpackChunkName: "AppointmentHome" */ "../views/appointment/home.vue"
          ),
        meta: {
          keepAlive: true,
          noHeader: true,
          title: "看诊预约",
        },
      },
      // confirm页面路由
      {
        path: "confirm",
        name: "AppointmentConfirm",
        component: () =>
          import(
            /* webpackChunkName: "AppointmentConfirm" */ "../views/appointment/confirm.vue"
          ),
        meta: {
          noHeader: true,
          // title: "预约确认",
        },
      },
      // success页面路由
      {
        path: "success",
        name: "AppointmentSuccess",
        component: () =>
          import(
            /* webpackChunkName: "AppointmentSuccess" */ "../views/appointment/success.vue"
          ),
        meta: {
          noHeader: true,
          title: "提交成功",
        },
      },
      // history页面路由
      {
        path: "history",
        name: "AppointmentHistory",
        component: () =>
          import(
            /* webpackChunkName: "AppointmentHistory" */ "../views/appointment/history.vue"
          ),
        meta: {
          keepAlive: true,
          noHeader: true,
          title: "历史记录",
        },
      },
      // history页面路由
      {
        path: "doctor",
        name: "AppointmentDoctor",
        component: () =>
          import(
            /* webpackChunkName: "AppointmentHistory" */ "../views/appointment/doctor.vue"
          ),
        meta: {
          noHeader: true,
          title: "专家预约",
        },
      },
    ],
  },
  {
    path: "/group",
    name: "Group",
    component: () =>
      import(
        /* webpackChunkName: "Booking" */ "../components/layouts/booking.vue"
      ),
    meta: {
      noHeader: true,
    },
    children: [
      {
        path: "add",
        name: "GroupAdd",
        component: () =>
          import(/* webpackChunkName: "GroupAdd" */ "../views/group/add.vue"),
        meta: {
          keepAlive: true,
          noHeader: true,
          title: "预约申请",
        },
      },
    ],
  },
  {
    path: "/selfCard",
    name: "selfCard",
    component: () =>
      import(
        /* webpackChunkName: "Booking" */ "../components/layouts/booking.vue"
      ),
    meta: {
      noHeader: true,
    },
    children: [
      {
        path: "add",
        name: "SelfCardAdd",
        component: () =>
          import(
            /* webpackChunkName: "SelfCardAdd" */ "../views/selfCard/add.vue"
          ),
        meta: {
          noHeader: true,
          title: "自助制卡",
        },
      },
      {
        path: "success",
        name: "SelfCardSuccess",
        component: () =>
          import(
            /* webpackChunkName: "SelfCardSuccess" */ "../views/selfCard/success.vue"
          ),
        meta: {
          noHeader: true,
          title: "提交成功",
        },
      },
      {
        path: "list",
        name: "SelfCardList",
        component: () =>
          import(
            /* webpackChunkName: "SelfCardList" */ "../views/selfCard/list.vue"
          ),
        meta: {
          noHeader: true,
          title: "历史记录",
        },
      },
      {
        path: "detail",
        name: "SelfCardDetail",
        component: () =>
          import(
            /* webpackChunkName: "SelfCardDetail" */ "../views/selfCard/detail.vue"
          ),
        meta: {
          noHeader: true,
          title: "历史记录详情",
        },
      },
    ],
  },
  {
    path: "/customer",
    name: "Customer",
    component: () =>
      import(
        /* webpackChunkName: "Customer" */ "../components/layouts/customer.vue"
      ),
    meta: {
      noHeader: true,
    },
    children: [
      {
        path: "search",
        name: "CustomerSearch",
        component: () =>
          import(
            /* webpackChunkName: "CustomerSearch" */ "../views/customer/search.vue"
          ),
        meta: {
          noHeader: true,
          title: "查找客户",
        },
      },
      // detail
      {
        path: "detail",
        name: "CustomerDetail",
        component: () =>
          import(
            /* webpackChunkName: "CustomerDetail" */ "../views/customer/detail.vue"
          ),
        meta: {
          noHeader: true,
          title: "客户详情",
        },
      },
    ],
  },
  {
    path: "/system",
    name: "System",
    component: () =>
      import(
        /* webpackChunkName: "System" */ "../components/layouts/customer.vue"
      ),
    meta: {
      noHeader: true,
    },
    children: [
      {
        path: "login/:redirect?",
        name: "SystemLogin",
        component: () =>
          import(
            /* webpackChunkName: "SystemLogin" */ "../views/system/login.vue"
          ),
        meta: {
          noHeader: true,
          title: "登录",
        },
      },
    ],
  },
  {
    path: "/allApp",
    name: "allApp",
    component: () =>
      import(/* webpackChunkName: "Salon" */ "../views/allApp.vue"),
    meta: {
      noHeader: true,
    },
  },
  {
    path: "/",
    redirect: "/home",
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.path == "/appointment/confirm") {
    if (to.query.mode == 1) {
      to.meta.title = "预约确认";
    } else if (to.query.mode == 2) {
      to.meta.title = "意向确认";
    } else if (to.query.mode == 3) {
      to.meta.title = "分诊确认";
    }
  }
  document.title = to.meta?.title || "圆和医疗";
  next();
});

export default router;
